module.exports = __webpack_public_path__ + "static/media/team.37801961.png";